import { CheckOutlined } from '@ant-design/icons';

import { PageHeader } from '../../../components/shared';
import { Button } from '../../../components/ui';
import { useDieuHuong } from '../../../hooks/useDuongDan';
import { useT } from '../../../i18n';
import { TaskNotificationList } from '../components/nhiem-vu/TaskNotificationList';
import { useDanhDauDaDoc, useThongBaoNhiemVu } from '../hooks/useNhiemVu';

const SO_TOI_DA = 100;
const TRANG_NHIEM_VU = '/xu-ly-van-ban/quan-ly-nhiem-vu';

/** Thông báo (`/thong-bao`): bảng tin hoạt động trên nhiệm vụ của người đang đăng nhập, như bản cũ. */
export function ThongBaoView() {
  const { t } = useT();
  const dieuHuong = useDieuHuong();
  const feed = useThongBaoNhiemVu(SO_TOI_DA);
  const daDoc = useDanhDauDaDoc();
  const chuaDoc = feed.data?.unread_count ?? 0;

  return (
    <div className="mx-auto max-w-3xl space-y-4 p-4">
      <PageHeader
        title={t('vanBanNhiemVu.thongBao.tieuDeTrang')}
        subtitle={t('vanBanNhiemVu.thongBao.moTaTrang')}
        actions={
          chuaDoc > 0 && (
            <Button variant="outline" icon={<CheckOutlined />} loading={daDoc.isPending} onClick={() => daDoc.mutate()}>
              {t('vanBanNhiemVu.thongBao.danhDauDaDoc')}
            </Button>
          )
        }
      />
      <div className="overflow-hidden rounded-lg border border-default bg-surface shadow-sm">
        <TaskNotificationList
          items={feed.data?.items}
          loading={feed.isLoading}
          error={feed.isError}
          onRetry={() => void feed.refetch()}
          onOpen={(item) => dieuHuong(`${TRANG_NHIEM_VU}?task=${encodeURIComponent(item.task_id)}`)}
        />
      </div>
    </div>
  );
}
